import { render, staticRenderFns } from "./RegistrationRoot.vue?vue&type=template&id=b6ff48a8"
import script from "./RegistrationRoot.vue?vue&type=script&lang=ts"
export * from "./RegistrationRoot.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports